












import Vue from "vue";
import DialogWrapper from "@/components/dialog/DialogWrapper.vue";

/**
 * @Emits delete if delete button is clicked
 */
export default Vue.extend({
  name: "DeleteDialog",
  components: { DialogWrapper },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: "Dieses Element wirklich entfernen?",
    },
  },
  data: function () {
    return { open: this.value };
  },
  watch: {
    value() {
      this.open = this.value;
    },
    open() {
      this.$emit("input", this.open);
    },
  },
  methods: {
    onDelete() {
      this.$emit("delete");
    },
  },
});
